import { PageShell } from "../components/PageShell";

export function Home() {
  return (
    <PageShell title="Home" activeNavLink="Home">
    </PageShell>
  );
}